// extracted by mini-css-extract-plugin
module.exports = {"reportForm":"style__reportForm__MKeXy","shapeReport":"style__shapeReport__8u7cG"};